import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { useStates } from '@alamo/api';
import type { State } from '@alamo/types';
import { EntitySelect, type EntitySelectOption } from '@alamo/ui';

export interface GeographicStateSelectProps {
  label?: string;
  placeholder?: string;
  value: string | null;
  onChange: (id: string | null, item: State | null) => void;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  helperText?: string;
  className?: string;
}

export function GeographicStateSelect({
  label,
  placeholder,
  value,
  onChange,
  required,
  disabled,
  error,
  helperText,
  className,
}: GeographicStateSelectProps) {
  const { t } = useTranslation();
  const { data, isLoading } = useStates();

  const options: EntitySelectOption<State>[] = useMemo(() => {
    return (data ?? []).map((s) => ({
      value: s.id,
      label: s.name,
      hint: s.uf,
      data: s,
    }));
  }, [data]);

  return (
    <EntitySelect<State>
      label={label ?? t('common:entity_select.state_label')}
      placeholder={placeholder ?? t('common:entity_select.state_placeholder')}
      value={value}
      onChange={onChange}
      options={options}
      loading={isLoading}
      loadingMessage={t('common:entity_select.loading')}
      emptyMessage={t('common:entity_select.no_results')}
      required={required}
      disabled={disabled}
      error={error}
      helperText={helperText}
      className={className}
    />
  );
}
